// extracted by mini-css-extract-plugin
export default {"wrapperLoading":"Graficos_wrapperLoading__Nz+tV"};